import NewQuoteCard from "../pages/client/cards/new-quote-card";

export default function CardActions() {
  return (
    <div className="flex flex-col gap-6 mt-10 lg:mt-0">
      <NewQuoteCard onClick={() => window.open("/fazer-cotacao", "_blank")} />
    </div>
  );
}
